module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.4679da50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yieldspotter-favicon/safari-pinned-tab.svg
// module id = 402
// module chunks = 0